<article class="{{identificadorArticle}}">
    <div class="blq-cont">
        <h2 class="section-tit2 isotipo-stroke">{{paquete?.nombre}}</h2>
        <div class="duracion">Duración {{duracion}}h</div>
        <div class="minimo" *ngIf="textoEdadMinima">
            <div class="iconoEdad">
                <img class="imgWhite" src="assets/images/icons/mdi-o-more_time.svg" alt="" />
                <img class="imgBlack" src="assets/images/icons/mdi-o-more_time-negative.svg" alt="" />
                <span class="edad">{{textoEdadMinima}}</span>
            </div>
            <span>Edad mínima<br />{{textoEdadMinima}} años</span>
        </div>
        <neo-span-inner-html [contenido]="descripcion"></neo-span-inner-html>

        <div class="precio">
            <div class="precio-pvp">Precio 10 niños: {{paquete.precio1 | number: '1.0-0'}}€</div>
            <div class="precio-nota">Niño adicional: {{paquete.precio2 | number: '1.0-0'}}€</div>
        </div>
        <div class="horario" *ngIf="descripcionHorario.length">
            <i class="icon-20 icon-ibm--time"></i>
            <div>
                <strong>HORARIO:</strong>
                <br />
                <neo-span-inner-html [contenido]="descripcionHorario"></neo-span-inner-html>
            </div>
        </div>
        <div class="extra" *ngIf="descripcionExtra.length">
            <div class="extra-tit">Y además...</div>
            <div class="extra-txt">
                <neo-span-inner-html [contenido]="descripcionExtra"></neo-span-inner-html>
            </div>
        </div>
        <a class="btn btn-primary" (click)="reservar(paquete.id)" title="">
            Reserva ahora
        </a>
    </div>
    <div class="blq-img">
        <picture *ngFor="let imagen of paquete?.ficheros">
            <img src="{{imagen?.rutaAbsoluta}}" alt="" />
        </picture>
    </div>
</article>
<neo-proximamente-dlg [tituloDialog]="'proximamente_dlg_tit' | transloco"
    [descripcionDialog]="'proximamente_dlg_txt' | transloco">
</neo-proximamente-dlg>